// extracted by mini-css-extract-plugin
module.exports = {"select-custom-dropdown":"Select_select-custom-dropdown__2Wxa-","select-custom-div":"Select_select-custom-div__3mUsJ","select-custom-label":"Select_select-custom-label__3lY7i"};